import React from "react";
import { Container } from "react-bootstrap";
import "../../incidentes.css";

const items = [
  {
    titulo: "Fondos Institucionales",
    descripcion:
      "Tener fondos institucionales para las sesiones de Zoom " +
      "garantiza la continuidad profesional, la imagen corporativa, " +
      "el control administrativo y la trazabilidad de reuniones clave, " +
      "fortaleciendo la eficiencia y seguridad de las comunicaciones " +
      "empresariales y refuerza la identidad de la empresa y genera " +
      "confianza en clientes, socios y empleados.",
    acciones: [
      { label: "Descargar Fondos Institucionales", href: "zip/wallpapers-netjer.zip" },
    ],
  },
  {
    titulo: "Presentaciones corporativas",
    descripcion:
      "Contar con formatos oficiales estandariza la comunicación, " +
      "fortalece la imagen corporativa y asegura que los mensajes " +
      "transmitidos sean claros, consistentes y alineados a los valores de la empresa.",
    acciones: [
      { label: "Descargar Presentación Oscura", href: "pptx/netjer-networks-press-oscura.pptx" },
      { label: "Descargar Presentación Clara", href: "pptx/netjer-networks-press-clara.pptx" },
    ],
  },
  {
    titulo: "Iconografía",
    descripcion:
      "Asegura uniformidad visual, fortalece el reconocimiento " +
      "de la marca y mejora la comunicación visual en las presentaciones.",
    acciones: [
      { label: "Descargar Iconografía Oscura", href: "zip/iconografia-oscura.zip" },
      { label: "Descargar Iconografía Anaranjada", href: "zip/iconografia-anaranjada.zip" },
    ],
  },
];

const ImagenCorporativa = () => {
  const bucketUrl = process.env.REACT_APP_BUCKET;
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Imagen Corporativa</h1>
        </div>
        <div className="orgproc-grid-3col">
          {items.map((item, index) => (
            <div className="orgproc-card" key={item.titulo}>
              <div className="orgproc-card-accent"></div>
              <div className="orgproc-card-body">
                <div className="orgproc-eyebrow">Proceso #{index + 1}</div>
                <div className="orgproc-card-title">{item.titulo}</div>
                <p className="orgproc-card-desc">{item.descripcion}</p>
                <div className="orgproc-card-actions">
                  {item.acciones.map((accion) => (
                    <a
                      className="orgproc-card-btn"
                      href={`${bucketUrl}/${accion.href}`}
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                      key={accion.href}
                    >
                      {accion.label} →
                    </a>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </>
  );
};

export default ImagenCorporativa;

// https://app.diagrams.net/#G1HJo4V6_lXFNTb4mwHiA1kvTAdCy4tg1F
